/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log("Expanse theme (" + theme.settings.themeVersion + ") by ARCHΞTYPE | Learn more at https://archetypethemes.co");
}

(function () {
  "use strict";

  if (window.Shopify && window.Shopify.theme && navigator && navigator.sendBeacon && window.Shopify.designMode) {
    navigator.sendBeacon('https://api.archetypethemes.co/api/beacon', new URLSearchParams({
      shop: window.Shopify.shop,
      themeName: window.theme && window.theme.settings && `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
      role: window.Shopify.theme.role,
      route: window.location.pathname,
      themeId: window.Shopify.theme.id,
      themeStoreId: window.Shopify.theme.theme_store_id || 0,
      isThemeEditor: !!window.Shopify.designMode
    }))
  }

  theme.customerTemplates = function() {
    checkUrlHash();
    initEventListeners();
    resetPasswordSuccess();
    customerAddressForm();
  
    function checkUrlHash() {
      var hash = window.location.hash;
  
      // Allow deep linking to recover password form
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }
  
    function toggleRecoverPasswordForm() {
      var passwordForm = document.getElementById('RecoverPasswordForm').classList.toggle('hide');
      var loginForm = document.getElementById('CustomerLoginForm').classList.toggle('hide');
    }
  
    function initEventListeners() {
      // Show reset password form
      var recoverForm = document.getElementById('RecoverPassword');
      if (recoverForm) {
        recoverForm.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
  
      // Hide reset password form
      var hideRecoverPassword = document.getElementById('HideRecoverPasswordLink');
      if (hideRecoverPassword) {
        hideRecoverPassword.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
    }
  
    function resetPasswordSuccess() {
      var formState = document.querySelector('.reset-password-success');
  
      // check if reset password form was successfully submitted
      if (!formState) {
        return;
      }
  
      // show success message
      document.getElementById('ResetSuccess').classList.remove('hide');
    }
  
    function customerAddressForm() {
      var newAddressForm = document.getElementById('AddressNewForm');
      var addressForms = document.querySelectorAll('.js-address-form');
  
      if (!newAddressForm || !addressForms.length) {
        return;
      }
  
      // Country/province selector can take a short time to load
      setTimeout(function() {
        document.querySelectorAll('.js-address-country').forEach(el => {
          var countryId = el.dataset.countryId;
          var provinceId = el.dataset.provinceId;
          var provinceContainerId = el.dataset.provinceContainerId;
  
          new Shopify.CountryProvinceSelector(
            countryId,
            provinceId,
            {
              hideElement: provinceContainerId
            }
          );
        });
      }, 1000);
  
      // Toggle new/edit address forms
      document.querySelectorAll('.address-new-toggle').forEach(el => {
        el.addEventListener('click', function() {
          newAddressForm.classList.toggle('hide');
        });
      });
  
      document.querySelectorAll('.address-edit-toggle').forEach(el => {
        el.addEventListener('click', function(evt) {
          var formId = evt.currentTarget.dataset.formId;
          document.getElementById('EditAddress_' + formId).classList.toggle('hide');
        });
      });
  
      document.querySelectorAll('.address-delete').forEach(el => {
        el.addEventListener('click', function(evt) {
          var formId = evt.currentTarget.dataset.formId;
          var confirmMessage = evt.currentTarget.dataset.confirmMessage;
  
          if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            if (Shopify) {
              Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
            }
          }
        })
      });
    }
  };
  

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    if (theme.settings.isCustomerTemplate) {
      theme.customerTemplates();
    }

    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();
(function () {
  const state = {
    moved: false,
    currencyHome: null,
    currencyNode: null,
    trackHome: null,
    trackNode: null
  };

  function qs(sel, root = document) { return root.querySelector(sel); }

  function getCurrencyNode() {
    return qs('#SiteHeader .buckscc-currency-box');
  }

  function getTrackNode() {
    return qs('#SiteHeader a.track-order-link')
      || qs('#SiteHeader a[href*="/apps/track"]')
      || qs('#SiteHeader a[href*="track-order"]')
      || qs('#SiteHeader a[href*="track"]');
  }

  function ensurePillsContainer(drawer) {
    let pills = qs('.pawni-drawer-pills', drawer);
    if (pills) return pills;

    pills = document.createElement('div');
    pills.className = 'pawni-drawer-pills';

    // inserir logo a seguir ao UL do menu (debaixo das coleções)
    const menuList = qs('ul', drawer) || qs('nav ul', drawer) || qs('.mobile-nav ul', drawer);
    if (menuList && menuList.parentNode) {
      menuList.parentNode.insertBefore(pills, menuList.nextSibling);
    } else {
      drawer.appendChild(pills);
    }

    return pills;
  }

  function openDrawer() {
    const drawer = qs('#MobileNav');
    if (!drawer || !drawer.classList.contains('is-active')) return;

    const pills = ensurePillsContainer(drawer);

    // wrappers pill
    let currencyWrap = qs('.pawni-pill.pawni-pill--currency', pills);
    if (!currencyWrap) {
      currencyWrap = document.createElement('div');
      currencyWrap.className = 'pawni-pill pawni-pill--currency';
      pills.appendChild(currencyWrap);
    }

    let trackWrap = qs('.pawni-pill.pawni-pill--track', pills);
    if (!trackWrap) {
      trackWrap = document.createElement('div');
      trackWrap.className = 'pawni-pill pawni-pill--track';
      pills.appendChild(trackWrap);
    }

    // MOVE currency real
    const currency = state.currencyNode || getCurrencyNode();
    if (currency && !state.moved) {
      state.currencyNode = currency;
      state.currencyHome = currency.parentNode;
      state.currencyNext = currency.nextSibling;

      currencyWrap.appendChild(currency);
    }

    // MOVE track real (se quiseres mesmo o link original)
    const track = state.trackNode || getTrackNode();
    if (track) {
      // se já foi movido antes, não faz nada
      if (!state.trackNode) {
        state.trackNode = track;
        state.trackHome = track.parentNode;
        state.trackNext = track.nextSibling;
      }
      trackWrap.appendChild(track);
    } else {
      // fallback: cria link
      if (!qs('a', trackWrap)) {
        const a = document.createElement('a');
        a.className = 'pawni-track-fallback';
        a.href = '/apps/track123';
        a.textContent = 'Track Order';
        trackWrap.appendChild(a);
      }
    }

    state.moved = true;
  }

  function closeDrawer() {
    const drawer = qs('#MobileNav');
    if (!drawer || drawer.classList.contains('is-active')) return;
    if (!state.moved) return;

    // devolver currency ao sítio original
    if (state.currencyNode && state.currencyHome) {
      if (state.currencyNext && state.currencyNext.parentNode === state.currencyHome) {
        state.currencyHome.insertBefore(state.currencyNode, state.currencyNext);
      } else {
        state.currencyHome.appendChild(state.currencyNode);
      }
    }

    // devolver track ao sítio original
    if (state.trackNode && state.trackHome) {
      if (state.trackNext && state.trackNext.parentNode === state.trackHome) {
        state.trackHome.insertBefore(state.trackNode, state.trackNext);
      } else {
        state.trackHome.appendChild(state.trackNode);
      }
    }

    state.moved = false;
  }

  function handle() {
    const drawer = qs('#MobileNav');
    if (!drawer) return;

    if (drawer.classList.contains('is-active')) openDrawer();
    else closeDrawer();
  }

  function init() {
    const drawer = qs('#MobileNav');
    if (!drawer) return;

    // observa abrir/fechar
    const obs = new MutationObserver(handle);
    obs.observe(drawer, { attributes: true, attributeFilter: ['class'] });

    // primeira execução
    handle();

    // se o tema fecha o drawer clicando fora sem mudar class imediatamente
    document.addEventListener('click', () => setTimeout(handle, 50));
  }

  document.addEventListener('DOMContentLoaded', init);
})();